import { h, Component } from 'preact'
import {
    steps,
    // colors,
    // mountTypes,
    // initialState,
    language
} from './config'
import { API_URL } from '../main'

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        }

        $.ajax(API_URL + '/options.php?lang=' + language).done(data => {
            this.setState({loaded: true, ...data});
        });
    }

    getChildContext () {
        let { translations = {}, options = {} } = this.state;
        let { shade = [], cable = [], mount = [] } = options;
        return { config: {
            // colors,
            // mountTypes,
            initialState : {
                currentStep: steps[0],
                // shadeColor: colors.shade.basic[0],
                // cableColor: colors.cable.unicolor[0],
                // mountColor: colors.mount[0],
                // mountType: mountTypes[0],

                shade: shade[0],
                cable: cable[0],
                mount: mount[0]
            },

            steps,
            translations, 
            options
        } }
    }

    render ({children}, {loaded}) {
        return loaded ? {children} : '';
    }
}


// WEBPACK FOOTER //
// ./js/config/ConfigProvider.js